<label>Sourcing Assignee</label>
<ng-select
  [items]="goStaff"
  bindValue="id"
  [(ngModel)]="value"
  (change)="onChange()"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
      >×</span
    >
    {{ item.firstname + ' ' + item.lastname }}
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm"
  >
    <h6>{{ item.firstname + ' ' + item.lastname }}</h6>
  </ng-template>
</ng-select>
